import * as types from "../constants";
import { DashboardItems } from "../../Interfaces/Interfaces";

export function UpdateDashboard(DashboardItemsList: DashboardItems[]): types.UpdateDashboardItems {
    return {
        type: types.UPDATE_DASHBOARD_ITEMS,
        payload: DashboardItemsList
    };
}
